import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { ApiService } from "@app/services/api/api.service";
import { VesselGroupsService } from "@app/services/vessel-groups/vessel-groups.service";

@Injectable({
  providedIn: "root",
})
export class DataStorageService implements OnDestroy  {
  private selectedVessel;

  protected subject: BehaviorSubject<any>;
  private subscriptions: Subscription[] = [];

  constructor(
    private apiService: ApiService,
    private vesselGroupsService: VesselGroupsService
  ) {}

  initialize() {
    if (!this.subject) {
      this.subject = new BehaviorSubject<any>(undefined);

      this.subscriptions.push(
        this.vesselGroupsService.getSelectedVesselObservable().subscribe({
          next: (selectedVessel) => {
            this.setSelectedVessel(selectedVessel);
          },
        })
      );
    }
    return this.subject;
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  private setSelectedVessel(selectedVessel): void {
    if (selectedVessel !== this.selectedVessel) {
      this.selectedVessel = selectedVessel;
      this.subject.next(undefined);
    }
    if (this.selectedVessel) {
      const href = this.apiService.resolveLink(this.selectedVessel._links["fo:storage"].href);
      this.apiService
        .get(href)
        .toPromise()
        .then(
          (storage) => {
            this.subject.next(storage);
          },
          (error) => this.subject.next({})
        );
    }
  }
}
